import React from 'react';

import { css } from '@emotion/css';

import { Alert } from 'components/Alert';

export const PAYMENT_DEPRECATION_MESSAGE =
  'Starting on Monday, September 15th, new payment authorizations will no longer be supported in Recurrency. Payments that have already been authorized will continue to process as usual at the time of shipment. The Payment Portal will remain active so you can view and manage these existing transactions. Please contact Debra Watson at CWC for additional guidance.';

export const PaymentDeprecationBanner = () => (
  <div
    className={css`
      margin-top: 20px; /* Add top margin to push content down from nav bar */
      margin-bottom: 20px; /* Space before the payment title */
    `}
  >
    <Alert
      className={css`
        /* Complete override of banner position */
        &.ant-alert-banner {
          position: relative !important;
          top: auto !important;
          width: 100% !important;
          margin: 0 !important;
          border-radius: 4px !important;
        }

        /* More padding to ensure text is fully visible */
        .ant-alert-content {
          padding: 16px 8px;
        }

        .ant-alert-message {
          color: #cf1322; /* Red text color */
          font-weight: 500;
        }
      `}
      message={PAYMENT_DEPRECATION_MESSAGE}
      type="error"
      banner
      showIcon={false}
    />
  </div>
);
